/**
 * The fields required at intake that a deal on the pipeline can still be missing
 * (client item #1): the loan purpose, the city and state, the initial amount, the
 * fully funded amount.
 *
 * A deal the mail pipeline created is never refused for lacking one — it is
 * created and listed as missing it. The initial amount and the location are
 * already in `criticalMissing`; the fully funded amount defaults to the initial
 * amount when nothing is held back (so it is never missing while an amount is
 * there); what `criticalMissing` does not know is the loan purpose. That is this.
 *
 * Kept apart from `criticalMissing` on purpose: that function has a server twin
 * (`backend/app/reporting/view_grid.py::_critical_missing`) held to one parity
 * fixture, and the grid's exception count, the "Critical data missing" tile and
 * the server-built reports all read it. Adding the purpose there means changing
 * the twin and regenerating the fixture together — the work-package notes say
 * where. Until then the Deal Inspector lists it beside the critical gaps.
 */
import type { Loan } from '@/types'

/** Fields required at intake that this deal lacks and `criticalMissing` does not list. */
export function requiredAtIntakeMissing(loan: Pick<Loan, 'customFields'>): string[] {
  const missing: string[] = []
  if (!String(loan.customFields?.purpose ?? '').trim()) missing.push('purpose')
  return missing
}
